import { authService, invitesService, publisherRegistrationService, buyerRegistrationService } from '@/angularBridgeCode/ringbaPortal.servicesModule';
import { SET_ACTION_STATUS_PENDING, SET_ACTION_STATUS_SUCCESS, SET_ACTION_STATUS_ERROR, changeActionStatus, getActionStatusName } from '@/store/helpers';
import {
  SEND_LOGIN_REQUEST,
  SEND_FORGOT_PASSWORD_REQUEST,
  SEND_RESET_PASSWORD_REQUEST,
  SEND_JOIN_INVITE_REQUEST,
  SEND_PRP_REQUEST,
  SEND_LOGIN_REQUEST_WITH_TWO_FACTOR,
  SEND_RESET_PASSWORD_REQUEST_WITH_TWO_FACTOR,
  CLEAN_TWO_FACTOR_AUTH,
  SEND_BRP_REQUEST,
  REQUIRE_TWO_FACTOR
} from './actionTypes';

import {
  GET_TOKEN,
  GET_RESET_PASSWORD_TOKEN,
  SET_TWO_FACTOR_AUTH_REQUIRED,
  REMOVE_TWO_FACTOR_AUTH_REQUIRED,
  SET_TWO_FACTOR_METHOD_AS_SMS_OR_EMAIL
} from './mutationTypes';
import i18n  from '@/i18n.js';

export const AUTH_STATUS_REQUIRE_MFA = 'success';

const two_factor_errors = [
  'two_auth_sent',
  'two_auth_required'
];

const actions = {
  async [SEND_LOGIN_REQUEST]({ commit, rootState, dispatch }, loginRequest) {
    commit(SET_ACTION_STATUS_PENDING, {actionName: SEND_LOGIN_REQUEST });
    try {
      const response = await authService.login({
        userName: loginRequest.email,
        password: loginRequest.password,
        useRefreshTokens: loginRequest.remember
      });
      if (200 === response.status) {
        commit(SET_ACTION_STATUS_SUCCESS, {actionName: SEND_LOGIN_REQUEST });
      }
    } catch (error) {
      dispatch('requireTwoFactor', { actionName: SEND_LOGIN_REQUEST, tokenAction: GET_TOKEN, request: loginRequest, error: error });
    }
  },

  async [SEND_LOGIN_REQUEST_WITH_TWO_FACTOR]({ commit, state }, { validationCode }) {
    commit(SET_ACTION_STATUS_PENDING, { actionName: SEND_LOGIN_REQUEST_WITH_TWO_FACTOR });
    try {
      const response = await authService.login({
        userName: state.loginRequest.email,
        password: state.loginRequest.password,
        useRefreshTokens: state.loginRequest.remember,
        code: validationCode
      });
      if (200 === response.status) {
        commit(SET_ACTION_STATUS_SUCCESS, { actionName: SEND_LOGIN_REQUEST_WITH_TWO_FACTOR });
      }
    } catch (error) {
      commit(SET_ACTION_STATUS_ERROR, { actionName: SEND_LOGIN_REQUEST_WITH_TWO_FACTOR, error: error });
    }
  },

  async [SEND_FORGOT_PASSWORD_REQUEST]({ commit }, forgotPasswordRequest) {
    commit(SET_ACTION_STATUS_PENDING, {actionName: SEND_FORGOT_PASSWORD_REQUEST });
    try {
      await authService.requestPasswordReset({
        emailAddress: forgotPasswordRequest.email, 
        accountId: forgotPasswordRequest.accountId
      });
      commit(SET_ACTION_STATUS_SUCCESS, {actionName: SEND_FORGOT_PASSWORD_REQUEST });
    } catch (error) {
      commit(SET_ACTION_STATUS_ERROR, {actionName: SEND_FORGOT_PASSWORD_REQUEST, error: error });
    }
  },
  
  async [SEND_RESET_PASSWORD_REQUEST]({ commit, rootState, dispatch }, resetPasswordRequest) {
    commit(SET_ACTION_STATUS_PENDING, {actionName: SEND_RESET_PASSWORD_REQUEST });
    try {
      await authService.resetPassword(resetPasswordRequest);
      commit(SET_ACTION_STATUS_SUCCESS, { actionName: SEND_RESET_PASSWORD_REQUEST });
    } catch (error) {
      dispatch('requireTwoFactor', {actionName: SEND_RESET_PASSWORD_REQUEST, tokenAction: GET_RESET_PASSWORD_TOKEN, request: resetPasswordRequest, error: error });
    }
  },

  async [SEND_RESET_PASSWORD_REQUEST_WITH_TWO_FACTOR]({ commit, state }, { validationCode }) {
    commit(SET_ACTION_STATUS_PENDING, {actionName: SEND_RESET_PASSWORD_REQUEST_WITH_TWO_FACTOR });
    try {
      var response = await authService.resetPassword({
        token: state.resetPasswordRequest.token,
        id: state.resetPasswordRequest.id,
        password: state.resetPasswordRequest.password,
        confirmPassword: state.resetPasswordRequest.confirmPassword,
        code: validationCode
      });
      if (200 === response.status) {
        commit(SET_ACTION_STATUS_SUCCESS, { actionName: SEND_RESET_PASSWORD_REQUEST });
        commit(SET_ACTION_STATUS_SUCCESS, { actionName: SEND_RESET_PASSWORD_REQUEST_WITH_TWO_FACTOR });
        commit(REMOVE_TWO_FACTOR_AUTH_REQUIRED);
      }
    } catch (error) {
      commit(SET_ACTION_STATUS_ERROR, { actionName: SEND_RESET_PASSWORD_REQUEST_WITH_TWO_FACTOR, error: error });
    }
  },

  async [SEND_JOIN_INVITE_REQUEST]({ commit }, { inviteId, requestData }) {
    commit(SET_ACTION_STATUS_PENDING, {actionName: SEND_JOIN_INVITE_REQUEST });
    try {
      await invitesService.joinInvite(inviteId, requestData);
      commit(SET_ACTION_STATUS_SUCCESS, {actionName: SEND_JOIN_INVITE_REQUEST });
    } catch (error) {
      const errorMessage = error?.data?.error == '' ? i18n.t('ORP_GENERIC_ERROR') : null;
      commit(SET_ACTION_STATUS_ERROR, {actionName: SEND_JOIN_INVITE_REQUEST, error: error, errorMessage: errorMessage });
    }
  },

  async [SEND_PRP_REQUEST]({ commit }, { prpId, requestData }) {
    commit(SET_ACTION_STATUS_PENDING, {actionName: SEND_PRP_REQUEST });
    try {
      const response = await publisherRegistrationService.submitPRPForm(prpId, requestData);
      if (200 === response.status) {
        commit(SET_ACTION_STATUS_SUCCESS, {actionName: SEND_PRP_REQUEST });
      }
    } catch (error) {
      let errorMessage = null;
      if (error && error.data && error.data.message == '') {
        errorMessage = i18n.t('ORP_GENERIC_ERROR', { applicantType: 'Publisher' });
      }
      commit(SET_ACTION_STATUS_ERROR, {actionName: SEND_PRP_REQUEST, error: error, errorMessage: errorMessage});
    }
  },

  async [SEND_BRP_REQUEST]({ commit }, { brpId, requestData }) {
    commit(SET_ACTION_STATUS_PENDING, { actionName: SEND_BRP_REQUEST });
    try {
      const response = await buyerRegistrationService.submitBRPForm(brpId, requestData);
      if (200 === response.status) {
        commit(SET_ACTION_STATUS_SUCCESS, {actionName: SEND_BRP_REQUEST });
      }
    } catch (error) {
      let errorMessage = null;
      if (error && error.data && error.data.message == '') {
        errorMessage = i18n.t('ORP_GENERIC_ERROR', { applicantType: 'Buyer' });
      }
      commit(SET_ACTION_STATUS_ERROR, {actionName: SEND_BRP_REQUEST, error: error, errorMessage: errorMessage});
    }
  },

  async [CLEAN_TWO_FACTOR_AUTH]({ state, commit }) {
    changeActionStatus(state, { actionName: getActionStatusName(SEND_LOGIN_REQUEST), status: {} });
    changeActionStatus(state, { actionName: getActionStatusName(SEND_RESET_PASSWORD_REQUEST), status: {} });
    changeActionStatus(state, { actionName: getActionStatusName(SEND_LOGIN_REQUEST_WITH_TWO_FACTOR), status: {} });
    commit(REMOVE_TWO_FACTOR_AUTH_REQUIRED);
  },

  async [REQUIRE_TWO_FACTOR]({ commit }, requireTwoFactor) {
    if (requireTwoFactor.error.data.error === 'two_auth_sent') {
      commit(SET_TWO_FACTOR_METHOD_AS_SMS_OR_EMAIL);
    }      
    if (two_factor_errors.includes(requireTwoFactor.error.data.error)) {
      commit(requireTwoFactor.tokenAction, requireTwoFactor.request);
      commit(SET_TWO_FACTOR_AUTH_REQUIRED);
      commit(SET_ACTION_STATUS_SUCCESS, {actionName: requireTwoFactor.actionName });
      return;
    }
    commit(SET_ACTION_STATUS_ERROR, { actionName: requireTwoFactor.actionName, error: requireTwoFactor.error });
  }
};

export default actions;